export default {
  name: 'Adescriptions',
  props: {
    title: { type: String, default: () => '标题' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div>
        <el-descriptions title={this.title} {...{ attrs }}>
          {data.length > 0 && data.map((a, b) => (
            <span key={b}>
              {a.render ? () => a.render(a) : <el-descriptions-item label={a.label}>{a.value}</el-descriptions-item>}
            </span>
          ))}
          {this.$slots.default && (<el-descriptions-item>{this.$slots.default}</el-descriptions-item>)}
        </el-descriptions>
      </div>
    );
  }
}